/* eslint-disable no-prototype-builtins */
import axios from 'axios'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import EditMediaItem from '../items/EditMediaItem'

import { positionChangeWidthSm, swipelyticsTurquoise } from '../../../../helpers/variableDefaults'
import { standardButton } from '../../../../helpers/buttons'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { standardErrorContainer } from '../../../../helpers/errors'
import { saveSuccessfulTypography, advisoryTypography } from '../../../../helpers/typographies'
import { Input, dummyBoxWidth, isMobile } from '../../../../helpers/globalHelpers'
import { modifyDatingProfileInDatabase } from '../../../../helpers/modifyInDatabase'
import { titleAndAdvisoryJSX, saveAndCancelButtonsJSX } from '../../../../helpers/commonJSX'

export const editMediaItemsJSX = (
  isDemo,
  user, setUser,
  datingProfile, setDatingProfile,
  previousDatingProfile, setPreviousDatingProfile,
  selectedMediaItemIndex, setSelectedMediaItemIndex, 
  newMediaItem, setNewMediaItem,
  openMediaItemSelectModal, setOpenMediaItemSelectModal,
  customCaptionSelected, setCustomCaptionSelected, customSubcaptionSelected, setCustomSubcaptionSelected,
  openPromptSelectModal, openAboutMeSelectModal, openHobbySelectModal,
  loading, setLoading,
  saveSuccessful, setSaveSuccessful,
  errors, setErrors,
  resetLoadingAndErrors, resetSaveSuccessful,
  width
) => {

  const mediaItemIndexesArray = datingProfile.type.toLowerCase() === 'tinder' ? [0, 1, 2, 3, 4, 5, 6, 7, 8] : [0, 1, 2, 3, 4, 5]

  const tapDisabled = () => {
    return (
      openPromptSelectModal 
      || openAboutMeSelectModal 
      || openHobbySelectModal
      || loading.loading
      || loading.mediaItems
      || loading.aboutMe
      || loading.prompts
      || loading.hobbies
      || loading.selectMediaItem
      || loading.selectAboutMe
      || loading.selectPrompt
      || loading.selectHobby
    )
  }

  const showSaveAndCancelButtons = () => {
    // console.log('mediaItem.url ->', Object.keys(mediaItem).length > 0 ? mediaItem.url : 'No Url')
    // console.log('previousURL ->', previousURL)
    // console.log('mediaItem.url === previousURL ->', mediaItem.url === previousURL)
    // console.log('datingProfile.media ->', datingProfile.media)
    return !(
      Object.keys(datingProfile).length > 0
      && 'media' in datingProfile
      && datingProfile.media.length === previousDatingProfile.media.length
      && 
        datingProfile.media.filter((item, itemIndex) => ((itemIndex > previousDatingProfile.media.length) || !('mediaItemId' in item) || (item.mediaItemId !== previousDatingProfile.media[itemIndex].mediaItemId) || (item.caption !== previousDatingProfile.media[itemIndex].caption) || (item.subcaption !== previousDatingProfile.media[itemIndex].subcaption))).length === 0 
    )
  }

  const handleSelectItem = (e, selectedIndex) => {
    // console.log('handleSelectItem runs')
    e.preventDefault()
    if (
      !(tapDisabled())
    ) {
      resetLoadingAndErrors()
      resetSaveSuccessful()
      setSelectedMediaItemIndex(datingProfile.media.length < selectedIndex ? datingProfile.media.length : selectedIndex)
      setNewMediaItem({
        ...newMediaItem,
        mediaItemId: datingProfile.media.length > selectedIndex ? datingProfile.media[selectedIndex].mediaItemId : '',
        mediaItemURL: datingProfile.media.length > selectedIndex ? datingProfile.media[selectedIndex].mediaItemURL : '',
        mediaItemDuration: datingProfile.media.length > selectedIndex ? datingProfile.media[selectedIndex].mediaItemDuration : -1,
        mediaItemThumbnail: datingProfile.media.length > selectedIndex ? datingProfile.media[selectedIndex].mediaItemThumbnail : 'NA',
        mediaType: datingProfile.media.length > selectedIndex ? datingProfile.media[selectedIndex].mediaType : '',
        caption: datingProfile.media.length > selectedIndex ? datingProfile.media[selectedIndex].caption : 'No Caption',
        subcaption: datingProfile.media.length > selectedIndex ? datingProfile.media[selectedIndex].subcaption : '',
      })
      setOpenMediaItemSelectModal(true)
    }
  }

  const handleDeleteItem = (e, selectedIndex) => {
    // console.log('handleDeleteItem runs')
    e.preventDefault()
    if (
      !(tapDisabled())
    ) {

      resetLoadingAndErrors()
      resetSaveSuccessful()
    
      const newMediaItems = [ ...datingProfile.media ]
      // console.log('newMediaItems[selectedMediaItemIndex] ->', newMediaItems[selectedMediaItemIndex])
      // console.log('newMediaItems before splice ->', newMediaItems)
      // console.log('selectedMediaItemIndex ->', selectedMediaItemIndex)
      newMediaItems.splice(selectedIndex, 1)
      // console.log('newMediaItems after splice ->', newMediaItems)
      setDatingProfile({ ...datingProfile, media: newMediaItems })

      setNewMediaItem({})
      setSelectedMediaItemIndex(-1)
      setCustomCaptionSelected(false)
      setCustomSubcaptionSelected(false)
      setOpenMediaItemSelectModal(false)
    }
  }

  const handleCancelPressed = () => {
    // console.log('handleCancelPressed runs')
    setDatingProfile({ ...datingProfile, media: previousDatingProfile.media })
    resetSaveSuccessful()
  }

  const handleSavePressed = async () => {
    console.log('handleSavePressed runs')

    if (isDemo) {

      const updatedDatingProfilesForUser = user.datingProfiles.map((userDatingProfile, userDatingProfileIndex) => {
        return (
          userDatingProfile._id !== datingProfile._id 
            ?
            userDatingProfile
            :
            { 
              ...userDatingProfile,
              media: datingProfile.media,
            }
        )
      })
      setUser({ 
        ...user, 
        datingProfiles: [ ...updatedDatingProfilesForUser ],
      })

      setPreviousDatingProfile({ 
        ...previousDatingProfile, 
        media: datingProfile.media, 
      })
    } else {
      const objectToUpload = {
        media: datingProfile.media,
      }
      // console.log('objectToUpload ->', objectToUpload)

      await modifyDatingProfileInDatabase(`mediaItems`, datingProfile._id, objectToUpload, errors, setErrors, loading, setLoading)

      const updatedDatingProfilesForUser = user.datingProfiles.map((userDatingProfile, userDatingProfileIndex) => {
        return (
          userDatingProfile._id !== datingProfile._id 
            ?
            userDatingProfile
            :
            { 
              ...userDatingProfile,
              media: datingProfile.media,
            }
        )
      })
      setUser({ 
        ...user, 
        datingProfiles: [ ...updatedDatingProfilesForUser ],
      })

      setPreviousDatingProfile({ 
        ...previousDatingProfile, 
        media: datingProfile.media, 
      })
    }
  }

  const mediaItemDimension = (width) => {
    return width < 300 ? '75px' : width < 350 ? '85px' : width < 400 ? '100px' : width < 450 ? '115px' : width < 500 ? '125px' : width < 550 ? '135px' : width < 600 ? '145px' : width < 800 ? '140px' : '140px'
  }

  return (
    <Box
      sx={{
        py: 3, 
        // my: 2,
        width: width < positionChangeWidthSm ? '100%' : '90%',
        maxWidth: '600px',
        backgroundColor: showSaveAndCancelButtons() ? 'lightgray' : 'whitesmoke',
        borderRadius: width < positionChangeWidthSm ? 0 : 3, boxShadow: width < positionChangeWidthSm ? 3 : 3,
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '90%',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Input type="text" autoFocus="autoFocus" />
        </Box>

        {/* Title and Advisory JSX */}
        {titleAndAdvisoryJSX(
          // 'Photos/Videos', 
          'Photos', 
          datingProfile.type === 'hinge' 
            ?
            `*Tap to edit
            *Drag and drop to reorder`
            :
            `*Drag and drop to reorder`
          ,
          0
        )}


        {/* Media Items */}
        <Box
          sx={{
            // backgroundColor: 'pink',
            // py: 2, 
            width: '100%',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          {/* {console.log('isMobile ->', isMobile())} */}
          <DndProvider 
            // backend={HTML5Backend}
            backend={isMobile() ? TouchBackend : HTML5Backend}
            options={isMobile() 
              ? 
              { 
                ignoreContextMenu: true,
                // enableHoverOutsideTarget: true,
                // getDropTargetElementsAtPoint: true, 
              } 
              : 
              {

              }
            }
          >
            {mediaItemIndexesArray.map((mediaItemIndex) => (
              <Box
                key={mediaItemIndex}
                sx={{
                  mt: 1,
                  width: '33%',
                  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: (width < positionChangeWidthSm || mediaItemIndex % 3 === 1) ? 'center' : mediaItemIndex % 3 === 0 ? 'flex-end' : 'flex-start',
                  flexWrap: 'wrap',
                }}
              >
                {'media' in datingProfile && datingProfile.media !== null && datingProfile.media.length > 0 && datingProfile.media.length > mediaItemIndex
                  ?
                  <EditMediaItem mediaItem={datingProfile.media[mediaItemIndex]} mediaItemDimension={mediaItemDimension} datingProfile={datingProfile} setDatingProfile={setDatingProfile} mediaItemIndex={mediaItemIndex} loading={loading} tapDisabled={tapDisabled} handleSelectItem={handleSelectItem} handleDeleteItem={handleDeleteItem} openMediaItemSelectModal={openMediaItemSelectModal} />
                  :
                  <Box 
                    onClick={(e) => handleSelectItem(e, mediaItemIndex) }
                    disabled={tapDisabled()}
                    sx={{ 
                      // mt: 1,
                      backgroundColor: 'gray',
                      width: datingProfile.type === 'hinge' ? mediaItemDimension(width) : (.75 * parseFloat(mediaItemDimension(width))),
                      height: mediaItemDimension(width),
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      boxShadow: 3, 
                      borderRadius: '5px', 
                      cursor: tapDisabled() ? '' : 'pointer',
                      display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
                    }}
                  >
                    <AddIcon 
                      color='primary'
                      sx={{
                        // boxShadow: 3, 
                        borderRadius: '50%',
                        border: 2, 
                        borderColor: 'black',
                        backgroundColor: 'white',
                        width: '40px', height: '40px',
                      }}
                    />
                  </Box>
                }
                
              </Box>
            ))}
          </DndProvider>

          {/* Dummy Boxes */}
          {mediaItemIndexesArray.length > 3 && mediaItemIndexesArray.length % 3 > 0 &&

            (mediaItemIndexesArray.length % 3 === 1 ? [1, 2] : [1]).map( dummyIndex => (
              <Box
                key={dummyIndex}
                sx={{
                  mt: 1,
                  width: '33%',
                  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: (width < positionChangeWidthSm || dummyIndex % 3 === 1) ? 'center' : dummyIndex % 3 === 0 ? 'flex-end' : 'flex-start',
                  flexWrap: 'wrap',
                }}
              >
                {dummyBoxWidth(
                  mediaItemDimension(width),
                  2, 
                  dummyIndex
                )}
              </Box>
            ))
          }
        </Box>

        {/* Save and Cancel Buttons */}
        {showSaveAndCancelButtons()
          && saveAndCancelButtonsJSX(
            loading.mediaItems,
            (!(showSaveAndCancelButtons()) || loading.mediaItems),
            handleCancelPressed,
            handleSavePressed,
            0,
            0,
            2,
            'warning',
            'primary'
          )
        }

        {/* Loading */}
        {loading.mediaItems &&
          advisoryTypography(`Uploading Changes...`, 'center')
        }

        {/* Error Message */}
        {errors.mediaItems &&
          standardErrorContainer(`There was an error uploading the changes. Check your Internet connection and try again.`)
        }

        {/* Save Successful */}
        {saveSuccessful.mediaItems &&
          saveSuccessfulTypography()
        }
      </Box>
    </Box>
  )
}